export default __webpack_public_path__ + "static/media/ScanHand-Mobile-Frame.17403f0b.png";